import React from "react";
import { Col, Row } from "react-bootstrap";
import { AdminUser, DeviceBase } from "@preveil-api";
import { Account } from "src/common";
import { Loading } from "src/components";
import { DeviceRow } from ".";
import _ from "lodash";

type AllProps = {
  org_user: AdminUser;
  devices: DeviceBase[] | [];
  refresh: Function;
  loading: boolean;
  current_account: Account;
}

function ListViewComponent(props: AllProps) {
  const { devices, org_user, refresh, loading, current_account } = props;

  // Description: Render the device rows
  function RenderList() {
    return <div className="list-body">
      {_.map(devices, (device: DeviceBase, i: number) => {
        return <DeviceRow
          key={i}
          device={device}
          current_account={current_account}
          org_user={org_user}
          refresh={refresh}
        ></DeviceRow>;
      })}
    </div>;
  }

  function RenderEmptyView(message: string) {
    return (
      <div className="list-messages">
        <div>
          <div className="no-devices-image"></div>
          <p className="text-dark">{message}</p>
        </div>
      </div>
    );
  }

  return <div className={`settings-list ${loading ? " isloading" : ""}`}>
    {!!devices && devices.length > 0 ?
      <>
        <Row className="header-row">
          <Col sm={4} md={6}>Name</Col>
          <Col sm={3} md={4}>Status</Col>
        </Row>
        {RenderList()}
      </> : !loading && RenderEmptyView("No devices found")}
    {loading && <Loading noLogo={true} className="position-absolute" />}
  </div>;
}

export default React.memo(ListViewComponent);